import api from 'api';

export const loadBudget = api('POST /api/io/budget');
export const loadMonthlyBudget = api('POST /api/io/budget/monthly');
